import React from 'react';
import {
  Image,
  keyframes,
  usePrefersReducedMotion,
  Flex,
  Container,
  Link,
  Text,
} from '@chakra-ui/react';
import logo from '../../moon.jpg';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Spinner = props => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const animation = prefersReducedMotion
    ? undefined
    : `${spin} infinite 40s linear`;
  return (
    <Image
      animation={animation}
      src={logo}
      w={'40px'}
      h={'40px'}
      borderRadius={'full'}
      objectFit={'cover'}
      {...props}
    />
  );
};

function index(props) {
  return (
    <Flex
      bg={'rgba(0, 0, 0, 0.85)'}
      backdropFilter={'blur(12px)'}
      h={'80px'}
      align={'center'}
      w={'100%'}
      pos={'sticky'}
      top={0}
      zIndex={1000}
      borderBottom={'1px solid'}
      borderColor={'whiteAlpha.100'}
      px={4}
    >
      <Container maxW={'6xl'}>
        <Flex w={'full'} justifyContent={'space-between'} align={'center'}>
          <Flex align={'center'}>
            <Link
              href="/"
              display={'flex'}
              alignItems={'center'}
              _hover={{ textDecoration: 'none' }}
            >
              <Spinner mr={3} />
              <Text
                textTransform={'uppercase'}
                fontWeight={900}
                fontSize={'3xl'}
                color={'red.500'}
                letterSpacing={'wider'}
                _hover={{
                  color: 'white',
                }}
                transition={'color 0.2s'}
              >
                Ted
              </Text>
            </Link>
          </Flex>
          <Flex align={'center'}>
            <Link
              fontWeight={600}
              textTransform={'uppercase'}
              fontSize={'sm'}
              letterSpacing={'wider'}
              color={'whiteAlpha.800'}
              href="/"
              mr={6}
              position={'relative'}
              _hover={{
                textDecoration: 'none',
                color: 'white',
              }}
              transition={'color 0.2s'}
            >
              Home
            </Link>
            <Link
              fontWeight={600}
              textTransform={'uppercase'}
              fontSize={'sm'}
              letterSpacing={'wider'}
              color={'whiteAlpha.800'}
              href="/work"
              position={'relative'}
              _hover={{
                textDecoration: 'none',
                color: 'white',
              }}
              transition={'color 0.2s'}
            >
              My Work
            </Link>
          </Flex>
        </Flex>
      </Container>
    </Flex>
  );
}

export default index;
